import { render, staticRenderFns } from "./ChatsStats.vue?vue&type=template&id=c3eaf5fa&"
import script from "./ChatsStats.vue?vue&type=script&lang=js&"
export * from "./ChatsStats.vue?vue&type=script&lang=js&"
import style0 from "./ChatsStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports